import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    OnDestroy,
    QueryList,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { TabComponent } from './tab.component';
import { NgFor, NgClass, NgIf, NgTemplateOutlet, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'kb-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgFor,
        NgClass,
        NgIf,
        NgTemplateOutlet,
        TitleCasePipe,
    ],
})
export class TabsComponent implements AfterViewInit, OnDestroy {
    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

    selectedIndex = 0;
    private subscription: Subscription;

    constructor(private changeDetector: ChangeDetectorRef) {}

    ngAfterViewInit() {
        this.subscription = this.tabs.changes.subscribe(() => this.changeDetector.markForCheck());
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
